import React from "react";
import StaticContentPage from "./StaticContentPage";

const DEFAULT_AFTER_SALES_CONTENT = `<h2>Returns &amp; Exchanges</h2><p>We offer a 30-day return policy on all products. Items must be in original condition with all packaging intact.</p><h2>Warranty</h2><p>All frames come with a manufacturer's warranty against defects. Contact us for warranty claims.</p><h2>Contact Support</h2><p>For after-sale support, email us at support@tabrams.com or call +353 1 234 5678.</p>`;

const AfterSale = () => {
  return <StaticContentPage title="After Sale Support" contentKey="after_sales_content" fallbackContent={DEFAULT_AFTER_SALES_CONTENT} />;
};

export default AfterSale;
